"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isObjectId = function isObjectId(param) {
  return !!param.match(/^[a-fA-F0-9]{24}$/);
};

var _default = isObjectId;
exports["default"] = _default;
//# sourceMappingURL=isObjectId.js.map